import type { Account, AccountApi } from 'domain/Account';

export const mapAccountFromApi = (account: AccountApi): Account => {
  const { isRegistered, ...rest } = account;
  return {
    ...rest,
    isRegistrationCompleted: isRegistered, // Map backend property to frontend property
    displayName: `${account.firstName} ${account.lastName}`,
  };
};
